import "./App.css";
import React from "react";
import Pages from "@/pages/index.jsx";
import { Toaster } from "@/components/ui/toaster";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { ToastContainer } from "react-toastify";

Bugsnag.start({
  apiKey: "b29748792d780c4c1e3159a1900f36f3",
  plugins: [new BugsnagPluginReact()],
  otherOptions: {},
});

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const ErrorView = () => (
  <div>
    <p>An Error Occurred</p>
  </div>
);

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorView}>
      <Pages />
      <Toaster />
      <ToastContainer position="bottom-center" />
    </ErrorBoundary>
  );
}

export default App;
